import React from 'react';
import _ from 'lodash';
import { Box, Tooltip, Menu, MenuItem, Stack, Typography, Switch, FormControlLabel, Button } from '@mui/material';
import { DebounceInput } from 'react-debounce-input';
import { useSelector, useDispatch } from 'react-redux';
import ListIcon from '@mui/icons-material/List';
import { useMutation } from 'react-fetching-library';

import { CssTextField } from '../others/CssTextField';
import { setOLOrderSearchFields, setZSOrderSearchFields, setPLOrderSearchFields, setWROrderSearchFields } from '../../services/redux-actions';
import { getOrderColumns } from '../../services/functions';
import { useGetSeasonConfig } from '../../services/hooks';
import { updateEmployeeConfigAction } from '../../services/request';

export const OrderAdvancedFilter = props => {
  const { searchCallback } = props;
  const { mutate } = useMutation(updateEmployeeConfigAction);
  const { module, season, employeeId, employeeConfigId } = useSelector(state => state.app);
  const [reloadConfig, setReloadConfig] = React.useState(false);
  const { orderSearchFields } = useGetSeasonConfig(module, season, reloadConfig);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const setModuleSearchFields = data => {
    if (module === 'obozy') {
      return setOLOrderSearchFields({ [season]: data });
    } else if (module === 'zielone_szkoly') {
      return setZSOrderSearchFields({ [season]: data });
    } else if (module === 'polkolonie') {
      return setPLOrderSearchFields({ [season]: data });
    } else if (module === 'wyjazdy_rodzinne') {
      return setWROrderSearchFields({ [season]: data });
    }
  };

  const moduleSearchFieldsMutationBody = payload => {
    if (module === 'obozy') {
      return { ol_order_search_fields: payload, employee: employeeId };
    } else if (module === 'zielone_szkoly') {
      return { zs_order_search_fields: payload, employee: employeeId };
    } else if (module === 'polkolonie') {
      return { pl_order_search_fields: payload, employee: employeeId };
    } else if (module === 'wyjazdy_rodzinne') {
      return { wr_order_search_fields: payload, employee: employeeId };
    }
  };

  const handleChange = async (field, type) => {
    if (type == 'hide_all') {
      const { payload } = dispatch(setModuleSearchFields([]));
      await mutate(moduleSearchFieldsMutationBody(payload), employeeConfigId);
    } else if (type == 'show_all') {
      const { payload } = dispatch(setModuleSearchFields(getOrderColumns(module).slice(1)
        .map(obj => obj.field)));
      await mutate(moduleSearchFieldsMutationBody(payload), employeeConfigId);
    } else if (orderSearchFields.includes(field)) {
      const { payload } = dispatch(setModuleSearchFields(_.filter(orderSearchFields, item => item !== field)));
      await mutate(moduleSearchFieldsMutationBody(payload), employeeConfigId);
    } else {
      const { payload } = dispatch(setModuleSearchFields([...orderSearchFields, field]));
      await mutate(moduleSearchFieldsMutationBody(payload), employeeConfigId);
    }
    setReloadConfig(!reloadConfig);
  };

  return (
    <DebounceInput
      debounceTimeout={1000}
      style={{ width: 150, marginRight: 8 }}
      element={CssTextField}
      placeholder="Wyszukaj..."
      onChange={e => searchCallback(e.target.value)}
      variant="standard"
      InputProps={{
        endAdornment: (
          <>
            <Tooltip title="Kolumny do wyszukiwania">
              <ListIcon sx={{ cursor: 'pointer', color: '#00AB55' }} onClick={handleClick} />
            </Tooltip>
            <Menu
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button'
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  height: '50ch',
                  width: '34ch'
                }
              }}
            >
              {getOrderColumns(module).slice(1)
                .map(option => (
                  <MenuItem key={option.field} value={option.field}>
                    <FormControlLabel control={
                      <Switch
                        size="small"
                        checked={_.find(orderSearchFields, item => item == option.field) ? true : false}
                        onChange={() => handleChange(option.field)}
                      />
                    } label={option.headerName} />
                  </MenuItem>
                ))}
              <Stack direction="row" justifyContent="space-between" sx={{ p: 1 }}>
                <Button><Typography color="primary" onClick={() => handleChange(null, 'hide_all')}>Ukryj wszystko</Typography></Button>
                <Button><Typography color="primary" onClick={() => handleChange(null, 'show_all')}>Pokaż wszystko</Typography></Button>
              </Stack>
            </Menu>
          </>

        )
      }}
    />
  );
};
